function addToHolder(state, action){
  const { entity, type, id } = action.payload
  state.holder[entity][type] = [...state.holder[entity][type], id]
}

function emptyHolder(state, action){
  const {entity, type} = action.payload
  state.holder[entity][type] = []
}

export const holderFeature = {
  generateInitialState(){
    return {
      holder: {
        gallery: {
          delete: []
        }
      }
    }
  },
  generateReducer(){
    return {
      addToHolder,
      emptyHolder
    }
  },
}
